export default __webpack_public_path__ + "static/media/Map1-2.3769670e.png";